import { IJsonQuery, OfficeType, TOfficeType } from '../types/json-query';
import { ISpecialty } from '../types/offer';

export const customOfficeTitle = new Map<TOfficeType, string>([
  [OfficeType.Office, 'офис'],
  [OfficeType.TradeArea, 'торговую площадь'],
  [OfficeType.Warehouse, 'склад'],
  [OfficeType.Manufacture, 'производство'],
]);

export const TOP_OFFICE_TYPE: TOfficeType[] = [
  OfficeType.Office,
  OfficeType.TradeArea,
  OfficeType.Warehouse,
  OfficeType.Manufacture,
];

export const IGNORE_OFFICE_TYPE = OfficeType.FreeAppointmentObject as number;

export const MAP_SPECIALTY_OFFICE_TYPE = new Map<TOfficeType, number>([
  [OfficeType.Office, 7026],
  [OfficeType.TradeArea, 7128],
  [OfficeType.Warehouse, 7113],
  [OfficeType.Manufacture, 7104],
]);

export const getMultiPSNString = (
  jsonQuery: IJsonQuery,
  specialties: ISpecialty[],
  ignoreOfficeType = IGNORE_OFFICE_TYPE,
): string => {
  const typesFromQuery = (jsonQuery.office_type && jsonQuery.office_type.value.map(i => i as number)) || [];
  const specialtyIds = specialties.map(i => i.id);
  if (!typesFromQuery.includes(ignoreOfficeType)) {
    const topOfficeType = TOP_OFFICE_TYPE
      .map(officeType => {
        if (typesFromQuery.includes(officeType) && officeType) {
          const specialtyId = MAP_SPECIALTY_OFFICE_TYPE.get(officeType);

          if (specialtyIds.includes(specialtyId)) {
            const title = customOfficeTitle.get(officeType);

            if (title) {
              return title.toLowerCase();
            }

            return '';
          }

          return '';
        }

        return '';
      })
      .filter(f => f !== '');

    if (topOfficeType && topOfficeType.length > 0) {
      const specialtyString = topOfficeType.join(', ');

      return ` · Под ${specialtyString}`;
    }
  }

  return '';
};
